export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;

export const IS_TEST = import.meta.env.NODE_ENV === 'test';

export const IS_DEV = import.meta.env.DEV;

export const IS_PROD = import.meta.env.PROD;

export const VERSION = import.meta.env.VERSION;

let viteBase: string = import.meta.env.VITE_APP_BASE || '';
if (viteBase.endsWith('/')) {
  viteBase = viteBase.slice(0, -1);
}

export const BASE_PATH = viteBase;

export const IS_REVIEW = ENVIRONMENT === 'review';

export const FIGMA_APP_CLIENT_ID = 'xfcwZ1mCb2XmDQv0qGX9Zo';
